module.exports = __webpack_public_path__ + "img/2019tshirt.a8692b76.jpg";